document.addEventListener('DOMContentLoaded', function () {
  // Mapping-Funktion für den Checkout
  var mapForCheckout = function (str) {
    if (!str) return str;
    return str
      .replaceAll("Ã", "➡️")
      .replaceAll("Á", "⬅️")
      .replaceAll("Ê", "♿");
  };

  // Wendet Mapping auf beide Property-Felder im gegebenen Scope (Form) an
  var applyMappingToForm = function (form) {
    if (!form) return;
    var inputs = form.querySelectorAll('input[name="properties[Wunschtext]"], input[name="properties[Text]"]');
    if (!inputs.length) return;

    inputs.forEach(function (input) {
      // Originalwert merken, falls noch nicht gesichert
      if (input.dataset.originalValue === undefined) {
        input.dataset.originalValue = input.value;
      }

      // Checkout-Variante schreiben
      var mapped = mapForCheckout(input.value);
      input.value = mapped;

      // Falls Theme auf change/input hört (AJAX-Add)
      input.dispatchEvent(new Event('input',  { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // Nach kurzer Zeit Original zurücksetzen (nur wenn Seite nicht navigiert)
    setTimeout(function () {
      inputs.forEach(function (input) {
        if (input.dataset.originalValue !== undefined) {
          input.value = input.dataset.originalValue;
          delete input.dataset.originalValue;

          // Preview/Logik wieder anstoßen
          input.dispatchEvent(new Event('input',  { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
          // dein Custom-Event weiterwerfen (optional)
          window.dispatchEvent(new CustomEvent('option:changed', {
            bubbles: true,
            detail: {
              name: input.name.indexOf('[Wunschtext]') !== -1 ? 'Wunschtext' : 'Text',
              value: input.value,
              element: input
            }
          }));
        }
      });
    }, 1200); // ggf. je nach AJAX-Laufzeit anpassen
  };

  // 1) Klick auf Add-to-Cart-Button abfangen (delegiert – funktioniert auch mit Sections)
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest('button[name="add"]');
    if (!btn) return;

    var form = btn.closest('form');
    applyMappingToForm(form);
    // kein preventDefault – normaler Ablauf soll weitergehen
  }, true); // capture: true → kommt früh genug vor Theme-Handlern

  // 2) Backup: Bei Form-Submit ebenfalls mappen
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    // nur echte Add-to-Cart-Forms
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/i.test(form.getAttribute('action') || '')) return;

    applyMappingToForm(form);
    // kein preventDefault – Absenden zulassen
  }, true);
});

document.addEventListener("click", function (e) {
  const canvas = e.target.closest(".cl-po--canvas");
  if (!canvas) return;

 /* const target =
    document.querySelector('[data-option="Wunschtext"] input[name="properties[Wunschtext]"]') ||
    document.querySelector('[data-option="Text"] input[name="properties[Text]"]');
*/

  const target = document.querySelector('[data-option="Text"] input[name="properties[Text]"]');

  if (target) {
    target.scrollIntoView({ behavior: "smooth", block: "center" });
    setTimeout(() => target.focus(), 300);
  }
});

